import { css } from '@emotion/react'

const container = css`
  [role='presentation'] {
    max-width: 100%;
  }
`

export const styles = { container }
